import React, { useState } from 'react';
import './AboutPage.css';
import { useResponsiveQueries, S3_BASE_URL } from '../../utils/constants';
import { motion } from 'framer-motion'
import { fadeIn } from '../../variants';

const AboutRow1 = () => {
  const { MOBILE_WIDTH } = useResponsiveQueries();
  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (imageName) => {
    setLoadedImages((prev) => ({ ...prev, [imageName]: true }));
  };

  return (
    <div className='row1-container'>
      {!MOBILE_WIDTH &&
        <motion.div
          variants={fadeIn("right", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          style={{ position: 'relative' }}>
          <img
            className={`image ${loadedImages.Girl2 ? 'loaded' : ''}`}
            src={`${S3_BASE_URL}/images/Girl2.webp`}
            alt='Girl 2'
            loading='lazy'
            onLoad={() => handleImageLoad('Girl2')}
          />
        </motion.div>}
      <div className='label'>
        <motion.div
          variants={fadeIn("down", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='row-title' style={{ fontSize: 'clamp(40px, 5.5vw, 96px)', color: '#0D65D9' }}>
          ABOUT US
        </motion.div>
        <motion.div
          variants={fadeIn("up", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='row-subtitle' style={{ fontSize: 'clamp(16px, 2vw, 32px)' }}>
          Digital Entertainment is What We Do
        </motion.div>
      </div>
    </div>
  );
};

export default AboutRow1;